document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on ATC buttons
  const atcButtons = document.querySelectorAll('.loosid_track_addtocart');
  
  atcButtons.forEach(button => {
    button.addEventListener('click', function(e) {
        console.log("tracking_here..............")
      // Get theme from data attribute
      const theme = this.dataset.theme || 'unknown';
      const themeSlug = theme.toLowerCase().replace(/\s+/g, '-');
      
      // Fire GA4 event
      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart_click', {
          'theme': theme,
          'theme_slug': themeSlug,
          'event_category': 'ecommerce',
          'event_label': 'ATC Button Click'
        });
      }
      
      // Optional: Also publish Shopify custom event for extensibility
      if (window.ShopifyAnalytics && ShopifyAnalytics.lib.track) {
        ShopifyAnalytics.lib.track('Custom Event', null, {
          theme: theme,
          action: 'add_to_cart_click'
        });
      }
    });
  });
});